fragment PeepEngagementStats on Peep {
    id
    name
    engagementRating
    engagementStats {
        totalSentCount
        openRate
        clickRate
        replyRate
        permanentBounceCount
    }
    ... on Contact {
        hasHardBounced
    }
}
